/* tslint:disable */

declare var Object: any;
export interface ERPpurchaseInterface {
  "id"?: number;
}

export class ERPpurchase implements ERPpurchaseInterface {
  "id": number;
  constructor(data?: ERPpurchaseInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ERPpurchase`.
   */
  public static getModelName() {
    return "ERPpurchase";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ERPpurchase for dynamic purposes.
  **/
  public static factory(data: ERPpurchaseInterface): ERPpurchase{
    return new ERPpurchase(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ERPpurchase',
      plural: 'ERPpurchases',
      path: 'ERPpurchases',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ERPpurchase.ts